import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { solutionBenefits } from '../../data/content';
import { MOCKUP_URL } from '../../data/images';
export function SolutionSection() {
  return <section aria-labelledby="solution-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-170" data-mp="1joehp8h966p5">
      <div className="mx-auto max-w-5xl" data-id="element-171" data-mp="1oiiui8d798y5">
        <SectionHeading id="solution-heading" eyebrow="Barber Instructor Ready™ — Édition française" title={<>
              Votre enseignement mérite mieux que <Accent data-id="element-173" data-mp="23d5ilemnajdg">des cours improvisés.</Accent>
            </>} body="Six volumes complémentaires réunis pour vous aider à préparer, organiser et animer vos formations en barbering." data-id="element-172" data-mp="1tg0v9bh2chv2" />

        <ul className="mx-auto mt-10 grid max-w-3xl gap-x-8 gap-y-4 sm:grid-cols-2" role="list" data-id="element-174" data-mp="90peajdetfb8">
          {solutionBenefits.map(benefit => <li key={benefit} className="flex items-start gap-3 text-[15px] font-medium leading-snug text-brand-charcoal sm:text-[16px]" data-id="element-175" data-mp="d3c0o4rba811">
              <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-brand-cta" data-id="element-176" data-mp="3s0krv531q8iu">
                <CheckIcon className="h-3 w-3 text-brand-cta-text" strokeWidth={3} aria-hidden="true" data-id="element-177" data-mp="3n32ri333h1mg" />
              </span>
              {benefit}
            </li>)}
        </ul>

        <img src={MOCKUP_URL} alt="Le système complet Barber Instructor Ready — Édition française" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto mt-12 block w-full max-w-[560px] object-contain lg:max-w-[780px]" style={{
        filter: 'drop-shadow(0 30px 36px rgba(20, 40, 59, 0.18))'
      }} data-id="element-178" data-mp="jlkoc8y9oisd" />
      </div>
    </section>;
}